import * as React from "react"
import { SimpleBannerStyles } from "./SimpleBannerStyles"

const SimpleBanner = ({ children, title, subtitle }) => {
  return (
    <SimpleBannerStyles>
      {children}

      {title && (
        <div className="container">
          <div className="banner__content">
            <h2>{subtitle}</h2>
            <h1>
              {title}
              <span style={{ color: "var(--primary)" }}>.</span>
            </h1>
          </div>
        </div>
      )}
    </SimpleBannerStyles>
  )
}

export default SimpleBanner
